// import { Button, Modal } from 'antd'
import { lazy, useContext, useEffect, useRef, useState } from 'react'
import { showMessage } from './components/antd-comp/message'
import { locationContext } from './contexts/locationContext'
import { userContext } from './contexts/userContext'
import { getAppConfig } from './controllers/API'
import { getUserInfo } from './controllers/API/user'
import axios, { customFetch } from './controllers/request'
import { triggerLenovoBack } from './utils/lenovoBack'
import { setBaiyingBaseUrl } from './utils/smbLogin'

// App页面懒加载
const App = lazy(() => import('./App'))

/**
 * 登录逻辑修改，使用联想百应跳转带入的authorCode进行登录认证
 * login_mode === 0               根据localStorage的fe-login-mode判断
 * login_mode === 1               进入本地登录
 * login_mode === 2               获取联想token并进行验证
 *
 * Sbm          联想百应缩写
 */
export default function AuthPage() {
  const [loading, setLoading] = useState(true)
  const [needAuth, setNeedAuth] = useState(false)
  const [errMsg, setErrMsg] = useState('认证失败，')

  const envInfo = useRef({
    mode: 1,
    baiyingUrl: 'https://smbpaasadmin.lenovo.com',
    baiyingApiUrl: 'https://paastest.baiying.com.cn', // 联想百应企管后台接口地址
    backUrl: localStorage.getItem('lenovo-back-url') || 'https://smbpaasadmin.lenovo.com'
  })

  const { setAppConfig } = useContext(locationContext)
  const { setUserInfo } = useContext(userContext)

  const waitTime = useRef(0)
  /** 记录登录成功后的目标路由，命中时直接跳转，避免先渲染首页再二次跳转 */
  const pendingRedirectPath = useRef<string>('')
  /** 是否来自分享链接，用于给目标页打标 */
  const fromShareLink = useRef(false)

  /**
   * 解析 ctx 获取目标路由，登录成功后统一跳转
   */
  const resolveRedirectFromCtx = (ctx?: string) => {
    if (!ctx) return
    try {
      const decodedCtx = decodeURIComponent(ctx)
      const parts = decodedCtx.split('_')
      if (parts.length >= 2 && parts[0] === 'bclab') {
        const app_id = parts[parts.length - 1]
        if (app_id) {
          pendingRedirectPath.current = `/experience/${app_id}`
          fromShareLink.current = true
        }
      } else if (parts.length >= 2 && parts[0] === 'initAssistant') {
        const path = parts[parts.length - 1]
        if (path) {
          pendingRedirectPath.current = path.startsWith('/') ? path : `/${path}`
          fromShareLink.current = false
        }
      }
    } catch (e) {
      console.warn('ctx参数解析失败：', e)
    }
  }

  const handleAuthStatus = (loading = false, needAuth = true) => {
    setLoading(loading)
    setNeedAuth(needAuth)
    if (needAuth) {
      // 微前端场景下不能在子应用 iframe 内直接加载联想登录页
      triggerLenovoBack({
        backUrl: envInfo.current.backUrl || 'https://smbpaasadmin.lenovo.com'
      })
    }
  }

  const checkLoginMode = () => {
    getAppConfig()
      .then((res: any) => {
        console.log(`=====登录模式：【${res.login_mode}】=====`)
        const resEnv = {
          mode: res.login_mode || 2,
          isDev: res.env === 'dev',
          libAccepts: res.uns_support,
          officeUrl: res.office_url,
          dialogTips: res.dialog_tips,
          dialogQuickSearch: res.dialog_quick_search,
          websocketHost: res.websocket_url || window.location.host,
          baiyingUrl: res.baiying_url || 'https://smbpaasadmin.lenovo.com', // 联想百应企管后台接口地址
          baiyingApiUrl: res.baiying_api_url || 'https://paastest.baiying.com.cn', // 联想百应企管后台接口地址
          baiyingFilesUrl: res.baiying_files_url || 'https://test-shop-pub-gateway.baiying.com.cn', // 联想云空间接口地址
          baiyingEnterPriseConfigUrl: res.baiying_enterprise_config_url || 'https://bot-test.baiying.com.cn' // 联想账号注销接口地址
        }
        if (res.login_mode === 0) {
          const feMode = localStorage.getItem('fe-login-mode')
          resEnv.mode = feMode ? parseInt(feMode) : 2
        }
        // resEnv.mode = 1
        setAppConfig(resEnv)
        setBaiyingBaseUrl(resEnv.baiyingUrl)
        envInfo.current = {
          mode: resEnv.mode,
          baiyingUrl: resEnv.baiyingUrl,
          baiyingApiUrl: resEnv.baiyingApiUrl,
          backUrl: resEnv.baiyingUrl
        }
        localStorage.setItem('fe-login-mode', resEnv.mode)
        judgeLoginStatus(resEnv.mode)
      })
      .catch(error => {
        console.error(error)
        showMessage({
          content: '登录模式加载错误，请检查网络环境',
          type: 'error'
        })
      })
  }

  // const judgeLoginStatus = mode => {
  //   const queryParams = new URLSearchParams(window.location.search)
  //   const feLoginMode = queryParams.get('feLoginMode')
  //   if (feLoginMode) {
  //     mode = parseInt(feLoginMode) || 1
  //     localStorage.setItem('fe-login-mode', feLoginMode)
  //   }
  //   if (mode === 1) {
  //     setLocalUserInfo()
  //     return
  //   }

  //   if (mode === 2) {
  //     const queryParams = new URLSearchParams(window.location.search)
  //     const authorCode = queryParams.get('authorCode')
  //     const backUrl = queryParams.get('fromRoute')
  //     console.log('联想参数：', window.location.href, authorCode, backUrl)
  //     if (backUrl) {
  //       const fullUrl = window.location.hash ? backUrl + window.location.hash : backUrl
  //       envInfo.current.backUrl = fullUrl
  //       localStorage.setItem('lenovo-back-url', fullUrl)
  //     }
  //     if (authorCode) {
  //       getUserTokenByAuthorCode(authorCode)
  //     } else {
  //       verifyLenovoLoginStatus(false)
  //     }
  //   }
  // }
  const removeInvalidFromRoute = () => {
    try {
      const url = new URL(window.location.href)
      const params = url.searchParams
      const fromRoute = params.get('fromRoute')

      if (fromRoute) {
        const suspiciousPatterns = [
          /javascript:/i,
          /eval\(/i,
          /alert\(/i,
          /confirm\(/i,
          /prompt\(/i,
          /document\./i,
          /window\./i,
          /<script>/i,
          /onerror=/i,
          /onload=/i
        ]

        if (suspiciousPatterns.some(pattern => pattern.test(fromRoute))) {
          params.delete('fromRoute')
          // 用 replaceState 替换当前 URL，去除非法参数，保持页面不刷新
          const newSearch = params.toString()
          const newUrl = url.origin + url.pathname + (newSearch ? `?${newSearch}` : '') + url.hash
          window.history.replaceState({}, document.title, newUrl)
          console.warn('已从URL中移除非法的fromRoute参数')
        }
      }
    } catch (e) {
      console.warn('清理fromRoute参数失败:', e)
    }
  }

  const judgeLoginStatus = mode => {
    const queryParams = new URLSearchParams(window.location.search)
    const feLoginMode = queryParams.get('feLoginMode')
    if (feLoginMode) {
      mode = parseInt(feLoginMode) || 1
      localStorage.setItem('fe-login-mode', feLoginMode)
    }

    if (mode === 1) {
      setLocalUserInfo()
      return
    }

    if (mode === 2) {
      // 先清理非法的fromRoute参数，确保后续拿到的参数安全
      removeInvalidFromRoute()

      const params = new URLSearchParams(window.location.search)
      const authorCode = params.get('authorCode')
      const backUrl = params.get('fromRoute')
      const ctx = params.get('ctx')

      console.log('联想参数：', window.location.href, authorCode, backUrl)

      if (backUrl) {
        try {
          // 这里做一遍严格安全校验（防止后续代码用到时误用）
          let decodedUrl = backUrl
          try {
            decodedUrl = decodeURIComponent(backUrl)
          } catch {}

          const safeUrl = new URL(decodedUrl, window.location.origin)

          // 只允许联想自家域名作为回跳地址，防止开放重定向攻击
          const ALLOWED_BACK_HOSTS = ['lenovo.com', 'baiying.com.cn', 'lenovomm.com']
          const isAllowedHost = (hostname: string) =>
            ALLOWED_BACK_HOSTS.some(h => hostname === h || hostname.endsWith('.' + h))

          if (safeUrl.protocol !== 'http:' && safeUrl.protocol !== 'https:') {
            console.warn('Unsafe backUrl ignored (invalid protocol):', backUrl)
          } else if (!isAllowedHost(safeUrl.hostname)) {
            console.warn('Unsafe backUrl ignored (host not in allowlist):', safeUrl.hostname)
          } else {
            const suspiciousPatterns = [
              /javascript:/i,
              /eval\(/i,
              /alert\(/i,
              /confirm\(/i,
              /prompt\(/i,
              /document\./i,
              /window\./i,
              /<script>/i,
              /onerror=/i,
              /onload=/i
            ]

            let hasSuspiciousParam = false
            safeUrl.searchParams.forEach(value => {
              if (suspiciousPatterns.some(pattern => pattern.test(value))) {
                hasSuspiciousParam = true
              }
            })

            if (hasSuspiciousParam) {
              console.warn('Unsafe backUrl ignored (query param contains suspicious content):', backUrl)
            } else {
              safeUrl.hash = ''
              const finalUrl = safeUrl.toString()
              envInfo.current.backUrl = finalUrl
              localStorage.setItem('lenovo-back-url', finalUrl)
            }
          }
        } catch (err) {
          console.warn('Invalid backUrl ignored:', backUrl)
        }
      }

      if (authorCode) {
        getUserTokenByAuthorCode(authorCode, ctx)
      } else {
        verifyLenovoLoginStatus(false)
      }
    }
  }

  const setLocalUserInfo = () => {
    getUserInfo()
      .then((res: any) => {
        const userInfo = {
          ...res
          // enterprise_id: 0
        }
        setUserInfo(userInfo).then(() => {
          handleAuthStatus(false, false)
        })
      })
      .catch(() => {
        // 获取用户失败会直接跳转到login
        handleAuthStatus(false, false)
      })
  }

  const getUserTokenByAuthorCode = (authorCode, ctx?: string) => {
    // 从URL中移除查询字符串，并保留hash部分
    const currentUrl = window.location.href
    const newUrl = currentUrl.split('?')[0]
    window.history.pushState({}, document.title, newUrl)
    // 走联想接口，不统一使用axios，因为错误需要单独处理
    customFetch(`${envInfo.current.baiyingApiUrl}/login-server/getUserTokenByAuthorCode?authorCode=${authorCode}`)
      .then(response => {
        console.log('getUserTokenByAuthorCode response', response)
        if (response.ok) {
          return response.json()
        } else {
          setErrMsg('Code无效，')
        }
      })
      .then(data => {
        console.log('getUserTokenByAuthorCode data', data)
        if (data.success) {
          localStorage.setItem('lenovo-token', data.data)
          localStorage.setItem('_SMB_token', data.data)
          // 提前解析跳转目标，待登录态落库后立即路由跳转，避免首页闪现
          resolveRedirectFromCtx(ctx)
          // 触发 token 验证与用户登录
          verifyToken(data.data, true)
        } else {
          setErrMsg(data.message + '，')
          handleAuthStatus(false, true)
        }
      })
      .catch(err => {
        console.error('authorCode error', err)
        handleAuthStatus(false, true)
      })
  }

  const verifyLenovoLoginStatus = (is_redirection = true) => {
    // 测试 token认证
    const token = localStorage.getItem('lenovo-token')
    if (token) {
      verifyToken(token, is_redirection)
    } else {
      handleAuthStatus(false, true)
    }
  }
  // token验证成功后端直接返回用户信息
  const verifyToken = (token, is_redirection = true) => {
    // 走联想接口，单独处理错误，跳过全局拦截
    axios
      .post(
        `/api/lenovo/getLoginInfo?is_redirection=${is_redirection}`,
        { is_redirection },
        {
          headers: {
            token,
            'X-Skip-Global-Error': 'true'
          },
          withCredentials: true
        }
      )
      .then(res => {
        const payload = res?.data ?? res
        const userInfo = payload?.data ?? payload
        if (!userInfo?.user_id) {
          setErrMsg('用户ID为空，')
          return
        }
        // getLoginInfo 新加参数  默认为true 页面中刷新的话传递为 false
        // localStorage.setItem('is_redirection', 'successs')
        // ws_token用来给WebSocket连接时使用
        localStorage.setItem('ws_token', userInfo.access_token)
        setUserInfo(userInfo).then(() => {
          // 命中分享/初始化跳转时，先用 replaceState 设好目标路由，再放行 App 渲染
          // RouterProvider 启动后会直接从当前 URL 匹配，无需二次跳转
          if (pendingRedirectPath.current) {
            if (fromShareLink.current) {
              sessionStorage.setItem('from-share-link', '1')
            }
            window.history.replaceState({}, document.title, pendingRedirectPath.current)
          }
          handleAuthStatus(false, false)
          // 通知登录完成
          window.dispatchEvent(new CustomEvent('login:success'))
        })
      })
      .catch(err => {
        // localStorage.setItem('is_redirection', 'error')
        console.error('verifyToken error', err)
        setErrMsg('登录状态已过期，')
        handleAuthStatus(false, true)
      })
  }

  useEffect(() => {
    checkLoginMode()
  }, [])

  // 每次切换菜单做一次token有效验证
  useEffect(() => {}, [])
  return (
    <>
      {loading && (
        <div className="absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center bg-[rgba(255,255,255,0.6)] dark:bg-blur-shared">
          <span className="loading loading-infinity loading-lg"></span>
        </div>
      )}
      {/* {needAuth && (
        <Modal
          title="认证失败"
          classNames={{
            mask: 'preload-error-mask'
          }}
          closable={false}
          open={true}
          footer={
            <Button
              type="primary"
              onClick={() => (window.location.href = envInfo.current.backUrl || 'https://smbpaasadmin.lenovo.com')}
            >
              确认
            </Button>
          }
        >
          <p>{errMsg}请点击确认重新授权登录</p>
        </Modal>
      )} */}
      {!loading && !needAuth && <App />}
    </>
  )
}
